<!--
 * @Description  : 场地门禁记录
 * @Author       : zcc
 * @Date         : 2025-04-09 10:01:48
 * @LastEditors: git config user.name
 * @LastEditTime: 2025-09-11 15:54:03
 * @FilePath: \ngs_platform_manage_admin\src\views\operation-management\site-entrance-records\index.vue
-->
<template>
  <div class="h100 site-entrance-records">
    <filter-layout
      @search="searchResult"
      @reset="resetSearch"
      v-if="!routeQuery"
      hasMore
	  hasHeader
    >
      <template #header>
        <el-tabs v-model="activeName" @tab-click="tabClick">
          <el-tab-pane label="全部" name="3"> </el-tab-pane>
          <el-tab-pane label="待生效" name="0"> </el-tab-pane>
          <el-tab-pane label="生效中" name="1"> </el-tab-pane>
          <el-tab-pane label="已失效" name="2"> </el-tab-pane>
        </el-tabs>
      </template>
      <template #filter>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchRef"
          label-width="120px"
          :model="searchObj"
        >
          <el-form-item label="门禁码/账号：">
            <el-input
              placeholder="请输入"
              clearable
              v-model.trim="searchObj.cardNo"
              size="small"
              :maxlength="30"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="设备序列号：">
            <el-input
              placeholder="请输入"
              clearable
              v-model.trim="searchObj.accessSerial"
              size="small"
              :maxlength="30"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="门禁名称：">
            <el-input
              placeholder="请输入"
              clearable
              v-model.trim="searchObj.accessName"
              size="small"
              :maxlength="30"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="场地名称：">
            <el-input
              placeholder="请输入"
              clearable
              v-model.trim="searchObj.siteName"
              size="small"
              :maxlength="30"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #more>
        <el-form
          class="flex-row-form colspan-4"
          size="small"
          ref="searchRef"
          label-width="120px"
          :model="searchObj"
        >
          <el-form-item label="会议室名称：">
            <el-input
              placeholder="请输入"
              clearable
              v-model.trim="searchObj.meetingName"
              size="small"
              :maxlength="30"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="门禁有效日期：">
            <el-date-picker
              v-model="searchObj.dateRange"
              type="daterange"
              unlink-panels
              start-placeholder="请选择"
              end-placeholder="请选择"
              :default-time="['00:00:00', '23:59:59']"
              size="small"
              value-format="yyyy-MM-dd"
              clearable
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="代理机构：">
            <el-input
              placeholder="请输入"
              clearable
              v-model.trim="searchObj.agency"
              size="small"
              :maxlength="30"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="操作人：">
            <el-input
              placeholder="请输入"
              clearable
              v-model.trim="searchObj.createUser"
              size="small"
              :maxlength="30"
            >
            </el-input>
          </el-form-item>
        </el-form>
      </template>
      <template #content>
        <div class="content-header">
          <div class="title"></div>
          <div class="btnGroups">
            <!-- <el-button
				type="primary"
				class="btn-blue"
				size="mini"
				@click="changeState"
			  >
				筛选
				<i v-if="searchToggle" class="el-icon-caret-bottom ml5"></i>
				<i v-else class="el-icon-caret-top ml5"></i>
			  </el-button> -->
            <el-button
              type="primary"
              class="ml5 btn-blue"
              size="mini"
              @click="resetSearch"
            >
              <i class="el-icon-refresh"></i>
            </el-button>
          </div>
        </div>
        <div class="w-table-layout w-table-page">
          <div class="w-table-content">
            <el-table
              ref="xTable"
              :data="tableObj.data"
              highlight-current-row
              align="left"
              height="100%"
              border
            >
              <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
                width="80"
              ></el-table-column>
              <el-table-column
                prop="accessStatus"
                label="状态"
                header-align="center"
                align="center"
                width="100"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.accessStatus == 0">待生效</el-tag>
                  <el-tag
                    type="success"
                    v-else-if="scope.row.accessStatus == 1"
                  >
                    生效中
                  </el-tag>
                  <el-tag type="danger" v-else-if="scope.row.accessStatus == 2">
                    已失效
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                prop="accessType"
                label="门禁类型"
                width="100"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.accessType == 0">门禁码</span>
                  <span type="success" v-else-if="scope.row.accessType == 1">
                    身份证
                  </span>
                  <span type="danger" v-else-if="scope.row.accessType == 2">
                    人脸
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                prop="cardNo"
                label="门禁码/账号"
                width="150"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="accessName"
                label="门禁名称"
                min-width="150"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="accessSerial"
                label="设备序列号"
                width="150"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                label="门禁有效时间"
                width="280"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  {{ scope.row.accessStart }} - {{ scope.row.accessEnd }}
                </template>
              </el-table-column>
              <el-table-column
                prop="siteName"
                label="场地名称"
                width="150"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="meetingName"
                label="会议室名称"
                width="150"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="packName"
                label="标段名称"
                width="150"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="agency"
                label="代理机构"
                width="150"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="createUser"
                label="操作人"
                width="100"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="createDate"
                label="操作时间"
                width="150"
                show-overflow-tooltip
              ></el-table-column>
              <!-- <el-table-column align="center" width="100">
				  <template slot="header">操作</template>
				  <template slot-scope="scope">
					<span v-if="scope.row.accessStatus != 0">
					  <el-button
						type="primary"
						size="small"
						round
						plain
						class="table-btn"
						v-if="roleBtns.includes('entryLog')"
						@click="openEntryLog(scope.row.id)"
					  >
						进场日志
					  </el-button>
					</span>
					<span v-else>-</span>
				  </template>
				</el-table-column> -->
            </el-table>
          </div>
          <div class="w-table-footer">
            <el-pagination
              v-if="showPagination"
              :current-page.sync="tableObj.currentPage"
              :page-sizes="tableObj.pageList"
              :page-size="tableObj.pageSize"
              :total="tableObj.total"
              layout="total, sizes, prev, pager, next, jumper"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </template>
    </filter-layout>
    <!-- 进场日志 -->
    <!-- <el-dialog
      :title="entryLogDialog.title"
      :visible.sync="entryLogDialog.visible"
      width="900px"
      center
      @close="entryLogDiaClose"
    >
      <entryLogDialog
        ref="entryLogDialog"
        :entryLog="entryLog"
      ></entryLogDialog>
    </el-dialog> -->
  </div>
</template>
<script>
import { getMeetingDoorRecordPage } from "api/modules/site-entrance-records";
// import entryLogDialog from "./components/entry-log-dialog.vue";
import { mapState } from "vuex";
import XEUtils from "xe-utils";

export default {
  name: "",
  // components: {
  //   entryLogDialog
  // },
  data() {
    return {
      name: "site-entrance-records",
      activeName: "3", //tab默认选中
      searchToggle: true, //筛选框状态 默认打开
      loading: true, //表格loading状态
      searchObj: {
        cardNo: "", //门禁卡号
        accessSerial: "", //门禁设备序列号
        accessName: "", //门禁名称
        siteName: "", //场地名称
        meetingName: "", //会议室名称
        dateRange: "", //门禁有效日期
        accessStart: "", //门禁有效时间（起）
        accessEnd: "", //门禁有效时间（止）
        agency: "", //代理机构
        createUser: "", //创建人
        accessStatus: "", //状态（不传查所有，0-待生效，1-生效中，2-已失效）
      },
      tableObj: {
        data: [],
        currentPage: 1, // 当前页码
        pageList: [10, 20, 50, 100], // 显示条数数组
        pageSize: 10, // 当前显示条数
        total: 0, // 当前总条数
      }, //表格页码
      showPagination: true, // 页码组件是否展示
      entryLogDialog: {
        visible: false, //对话框是否显示
        title: "进场日志", //标题
      }, // 场地门禁对话框
      entryLog: {
        id: "", //场地门禁对话框状体 区分新增编辑查看
      }, // 场地门禁对话框 父子组件传参
    };
  },
  computed: {
    ...mapState("menu", {
      roleBtns: (state) => state.roleBtns,
    }),
    routeQuery() {
      return this.$route.query.type;
    },
  },
  created() {
    this.getTablePageList();
  },
  methods: {
    // 搜索
    searchResult() {
      this.tableObj.currentPage = 1;
      this.tableObj.pageSize = 10;
      this.getTablePageList();
    },

    //tab选中
    tabClick(e) {
      this.searchObj.accessStatus = e; //状态（3-所有，0-待生效，1-生效中，2-已失效）
      this.searchResult();
    },

    // 切换状态
    changeState() {
      this.searchToggle = !this.searchToggle; //筛选框收起/展开
    },

    // 重置
    resetSearch() {
      this.searchObj = {}; //清空数据
      this.activeName = "3"; //tab返回全部
      this.searchResult();
    },

    // 获取预约记录
    getTablePageList() {
      //判断筛选框门禁有效日期是否有值
      if (this.searchObj.dateRange != "" && this.searchObj.dateRange != null) {
        this.searchObj.accessStart = this.searchObj.dateRange[0]; //起
        this.searchObj.accessEnd = this.searchObj.dateRange[1]; //止
      } else {
        this.searchObj.accessStart = "";
        this.searchObj.accessEnd = "";
      }
      let params = Object.assign({}, this.searchObj);
      this.loading = true;
      params.current = this.tableObj.currentPage; //当前页码
      params.size = this.tableObj.pageSize; //条数
      this.activeName == "3"
        ? (params.accessStatus = null)
        : (params.accessStatus = Number(this.activeName)); //当tab=3的时候默认传空
      this.tableObj.data = [];
      this.tableObj.total = 0;
      getMeetingDoorRecordPage(params)
        .then((res) => {
          if (res.code == 0) {
            this.tableObj.data = res.data.pageList.records; //表格数据
            this.tableObj.total = parseInt(res.data.totalNum); //合计
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },

    // 进场日志
    openEntryLog(id) {
      this.entryLog.id = id; //编辑/查看时 传选中行id
      if (this.$refs.entryLogDialog) {
        this.$refs.entryLogDialog.resetSearch(); //子组件表单重置
      }
      this.entryLogDialog.visible = true; //打开对话框
    },

    // 关闭 进场日志对话框
    entryLogDiaClose() {
      console.log("关闭对话框 :>> ");
    },

    // 切换显示条数
    handleSizeChange(val) {
      this.tableObj.pageSize = val;
      this.tableObj.currentPage = 1;
      this.getTablePageList();
    },

    //切换当前页码
    handleCurrentChange(val) {
      this.showPagination = false;
      this.$nextTick(() => (this.showPagination = true)); //防止组件未加载就赋值 导致赋值不上
      this.tableObj.currentPage = XEUtils.clone(val, true);
      this.getTablePageList();
    },
  },
};
</script>
<style lang="less" scoped>
.site-entrance-records {
  .operation-container {
    height: 100%;
  }

  /deep/ .vxe-cell--title {
    color: #202020;
    font-weight: normal;
  }
  .content-header{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0;
		.title {
			padding-left: 10px;
			border-left: 4px solid #2671cc;
			font-size: 14px;
			color: #202020;
		}
		.blue{
			font-size: 18px;
			color: #2671cc;
		}
	}
}

.toolbar {
  position: relative;

  .toolbar-right {
    position: absolute;
    right: 0;
    top: 0;
  }
}

/deep/ .el-tabs__item {
  width: 100px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #f0f0f0;
  border-radius: 3px 3px 0px 0px;
  color: #666;
  margin-right: 20px;
  padding: 0;

  .el-tabs__header {
    border-bottom: 1px solid #2671cc;
  }
}

/deep/ .el-tabs__item.is-active {
  color: #fff;
  background-color: #2671cc !important;
}

/deep/ .el-tabs__nav-wrap::after {
  background-color: #2671cc;
  height: 1px;
  z-index: 999;
}

/deep/ .el-tabs__active-bar {
  background-color: transparent;
}

.filter-box {
  border-bottom: none !important;
}

.operation-main {
  height: inherit !important;
  overflow: hidden;
}
</style>
